<template>
  <div id="app">
    <md-progress-spinner :md-diameter="100" :md-stroke="10" md-mode="indeterminate" v-if="!user"></md-progress-spinner>
    <router-view></router-view>
    <md-snackbar
      md-position="left"
      :md-duration="3000"
      :md-active.sync="displayNotification"
      md-persistent
    >
      <span>{{ this.notificationMessage }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      displayNotification: false
    };
  },
  computed: {
    ...mapState({
      user: s => s.auth.user,
      loading: s => s.auth.loading,
      showNotification: s => s.handbook.showNotification,
      notificationMessage: s => s.handbook.notificationMessage
    })
  },
  created() {
    this.fetchUser();
  },
  watch: {
    user: function(newUser) {
      if (newUser && newUser.roles && newUser.roles.includes("admin")) {
        this.$router.push("/admin");
      } else if (newUser && newUser.user_id) {
        this.$router.push("/handbook");
      }
    },
    showNotification: function(notify) {
      this.displayNotification = true;
    }
  },
  methods: {
    ...mapActions(["fetchUser"])
  }
};
</script>
<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
